import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';

import {ToastrService} from 'ngx-toastr';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../global/sessioncommand';
import {NavItemService} from '../../../service/staff/service-navitem';
import {environment} from '../../../../environments/environment';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';
import {ThongBao} from '../../../models/info/thongbao';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoFileService} from '../../../service/info/service-thongbaofile';
import {ThongBaoCommentService} from '../../../service/info/service-thongbaocomment';
import {ThongBaoComment} from '../../../models/info/thongbaocomment';
import {ThongBaoFile} from '../../../models/info/thongbaofile';
import {DomSanitizer} from '@angular/platform-browser';
import {LogView} from '../../../models/log/logview';
import {LogViewService} from '../../../service/log/service-logview';
import {ThongBaoStaff} from '../../../models/info/thongbaostaff';
import {ThongBaoStaffService} from '../../../service/info/service-thongbaostaff';
@Component({
  templateUrl: './tonghop.component.html',
  encapsulation: ViewEncapsulation.None

})
export class YKTongHopThongBaoComponent implements OnInit, AfterViewInit {
  public id: number = -1;
  public language = language;
  public showAction = true;
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public  onClose: Subject<boolean>;
  public thongBaoItem: ThongBao = new ThongBao();
  public thongBaoCommentList: ThongBaoComment[] = [];
  public thongBaoStaffList: ThongBaoStaff[] = [];
  public thongBaoFiles: ThongBaoFile [] =[];
  public logViewList: LogView[] = [];
  private dataComment: Object[] = [];
  constructor(
    public thongBaoService: ThongBaoService,
    public toastr: ToastrService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public thongBaoFileService: ThongBaoFileService,
    public navItemService: NavItemService,
    public bsModalService: BsModalService,
    public _bsModalRef: BsModalRef,
    public thongBaoCommentService: ThongBaoCommentService,
    public thongBaoStaffService: ThongBaoStaffService,
    public sanitizer: DomSanitizer,
    public logViewService: LogViewService

  ) {
  }
  ngAfterViewInit() {
  }
  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {
    this.onClose = new Subject();
  }


  public edit(id: number) {
    this.id = id;
    this.thongBaoService.getById(id).subscribe(data => this.thongBaoItem = data);
    this.thongBaoFileService.findAllByThongBaoId(id).subscribe(data => this.thongBaoFiles = data);
    this.thongBaoStaffService.findAllByThongBaoId(this.id).subscribe(x => {
      this.thongBaoStaffList = x;
      this.loadComment(this.id);
    });
  }

  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(false);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }
  public loadComment(id: number)
  {
    this.thongBaoCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.thongBaoCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data =>
      {
        this.thongBaoCommentList = data;
      });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.id);
  }

}

